import { FC, useState } from "react"
import YandexId from "@assets/svg/YandexId.svg?react" // ← важно: ?react (для Vite)
import { IconButton } from "@mui/material"
import { useYandexOAuth } from "@/app/data/oauth2/YandexOAuth2Provider"
import { ym } from "@/utils/metrika"

const YandexAuthButton: FC = () => {
	const [disabled, setDisabled] = useState(false)
	const openDialog = useYandexOAuth()
	const clickHandler = () => {
		setDisabled(true)
		setTimeout(() => {
			setDisabled(false)
		}, 3000)
		ym.authYandexClick()
		openDialog()
	}
	return (
		<IconButton
			disabled={disabled}
			onClick={clickHandler}
			size="large"
			sx={{
				bgcolor: "white",
				color: "black",
				border: "1px solid #e0e0e0",
				"&:hover": {
					bgcolor: "#fff8e1",
				},
				// Важно: делаем SVG нужного размера
				"& svg": {
					width: 28,
					height: 28,
				},
			}}
		>
			<YandexId />
		</IconButton>
	)
}

export default YandexAuthButton